module.exports = __webpack_public_path__ + "static/media/lifetime.f63724cf.png";